import type { CopyShape } from "../../intl";

import type { LANGUAGE_SETTINGS_COPY_PT_BR } from "../language-settings.copy";

export const LANGUAGE_SETTINGS_COPY_EN_US: CopyShape<typeof LANGUAGE_SETTINGS_COPY_PT_BR> = {
  title: "Language",
  description:
    "The language for Tãmi, your emails, and notifications. It's saved to your account and applies on web, mobile, and desktop.",
  groupLabel: "Tãmi language",
  caption: "Language for Tãmi, emails, and notifications",
  saveError: "We couldn't change the language. Try again.",
};
